define('lib/Podio.Router',['require','lib/prototype/Function.prototype','underscore','crossroads','lib/vendor/hasher','lib/Podio.Event','lib/Podio.Config','signals','lib/Podio.Logger'],function(require) {

  require('lib/prototype/Function.prototype');
  var _ = require('underscore');
  var crossroads = require('crossroads');
  var hasher = require('lib/vendor/hasher');
  var podioEvent = require('lib/Podio.Event');
  var podioConfig = require('lib/Podio.Config');
  var signalsLib = require('signals');
  var podioLogger = require('lib/Podio.Logger');

  var hashRouter, pathRouter;
  var isPushStateSupported = !!(window.history && window.history.pushState);
  var domReadyWaitQueue = [];
  var isDomReady = false;
  var onParsingStart =  new signalsLib.Signal();
  var routeObjects = {};
  var loggingEnabled = false;

  var pather = {
    rootPath : '/',
    changed : new signalsLib.Signal(),
    initialized : new signalsLib.Signal(),
    getPath : function() {
      var path = document.location.pathname;
      if (path.indexOf(this.rootPath) === 0) {
        path = path.substr(this.rootPath.length);
      }
      return path;
    },

    init : function() {
      var self = this;

      if(isPushStateSupported) {
        window.onpopstate = function() {
          pather.changed.dispatch(self.getPath(), [{ fromPopState: true }]);
        };
      }

      pather.initialized.dispatch(this.getPath());
    }
  };

  function getGlobalUrl() {
    return location.protocol + '//' + podioConfig.base_domain;
  }

  function getHashes() {
    var hash = hasher.getHash();
    var data = hash.slice(hash.indexOf('?') + 1).split('&');
    var dataMap = {};

    for (var i = 0; i < data.length; i++) {
      hash = data[i].split('=');
      dataMap[hash[0]] = hash[1];
    }

    return dataMap;
  }

  function serializeToQueryString(obj) {
    var str = [];
    for (var p in obj) {
      if(obj.hasOwnProperty(p)) {
        if(_.isArray(obj[p])) {
          obj[p] = obj[p].join(',');
        }
        str.push(p + "=" + encodeURIComponent(obj[p]));
      }
    }
    return '?' + str.join("&");
  }

  function goToRoute(mode, path, state, silent, handlerOptions) {
    var querystring = '';

    if(state) {
      querystring = serializeToQueryString(state);
    }

    if(mode === 'hash') {
      hasher.changed.active = !silent;
      window.location.hash = path + querystring;
      _.delay(function() {
        // Defer executing to after the hash has changed
        hasher.changed.active = true;
      }, 500);

    } else {
      window.history.pushState({}, '', path);
      if (!silent) {
        pathRouter.parse(pather.getPath(), _.compact([handlerOptions])); /* ensure empty array and not [undefined] when handlerOptions is undefined */
      }
    }
  }

  function addHashRoute(path, callback, options) {
    var route = hashRouter.addRoute(path, proxyRouteCallback.curry(hashRouter, callback));

    if(options && options.rules) {
      route.rules = options.rules;
    }
    // Check if current hash is matching added route
    if(route.match(hasher.getHash())) {
      if(!isDomReady && options && options.waitUntilDomReady) {
        domReadyWaitQueue.push( {
          type: 'hash',
          path: hasher.getHash()
        });
      } else {

        _.defer(function() {
          hashRouter.parse(hasher.getHash());
        });

      }
    }
  }

  function removeHashRoute(path) {
    hashRouter.removeRoute(routeObjects[path]);
  }

  function addRoute(path, callback, options) {
    var route = pathRouter.addRoute(path, proxyRouteCallback.curry(pathRouter, callback));

    routeObjects[path] = route;

    if(options && options.rules) {
      route.rules = options.rules;
    }

    // Check if current hash is matching added route
    if(route.match(pather.getPath())) {
      if(!isDomReady && options && options.waitUntilDomReady) {
        domReadyWaitQueue.push( {
          type: 'path',
          path: pather.getPath()
        });
      } else {

        _.defer(function() {
          pathRouter.parse(pather.getPath());
        });

      }
    }
  }

  function removeRoute(path) {
    pathRouter.removeRoute(routeObjects[path]);
  }

  function reloadCurrentPage() {
    window.location.reload();
  }

  function proxyRouteCallback(context, callback) {
    var args = _.toArray(arguments);
    var lastArgument = args[args.length - 1];
    var queries = {};
    var params, objectFreeArgs, optionsArr;
    var options = {};

    // handle query strings
    if (_.isObject(lastArgument)) {
      queries = lastArgument;
      // remove the last element
      args.splice(-1);
    }

    // remove context and callback from the arguments
    args = args.slice(2);

    // remove all objects from the params
    objectFreeArgs = _.reject(args, function(a) { return _.isObject(a); });
    optionsArr = _.filter(args, function(a) { return _.isObject(a); });
    optionsArr.forEach(function(o) { _.extend(options, o); });

    // add the routeData object in front
    params = [{ params: args, queries: queries, options: options }].concat(objectFreeArgs);

    if (loggingEnabled) {
      podioLogger.log('podioRouter routed:', document.location.toString());
    }

    callback.apply(context, params);
  }

  function enableLogging() {
    loggingEnabled = true;
  }

  function disableLogging() {
    loggingEnabled = false;
  }

  function init() {
    // Router for location hash
    hashRouter = crossroads.create();
    // we don't want crossroads to prevent triggering the same route twice in a row
    hashRouter.ignoreState = true;

    hasher.initialized.add(hashRouter.parse, hashRouter);
    hasher.changed.add(function(newHash, oldHash) {
      hashRouter.parse.call(hashRouter, newHash);
    });
    hasher.init();

    // Router for location path
    pathRouter = crossroads.create();
    // we don't want crossroads to prevent triggering the same route twice in a row
    pathRouter.ignoreState = true;
    pather.initialized.add(pathRouter.parse, pathRouter);
    pather.changed.add(pathRouter.parse, pathRouter);
    pather.init();
  }

  init();

  function onDomReady() {

    isDomReady = true;
    onParsingStart.dispatch();
    if(domReadyWaitQueue.length) {
      _.each(domReadyWaitQueue, function(route) {
        if(route.type == 'hash') {
          hashRouter.parse(route.path);
        } else {
          pathRouter.parse(route.path);
        }
      });
    }
  }

  podioEvent.bind(podioEvent.Types.init, onDomReady);

  return {
    getGlobalUrl : getGlobalUrl,
    getHashes: getHashes,
    addHashRoute: addHashRoute,
    addRoute: addRoute,
    removeRoute: removeRoute,
    removeHashRoute: removeHashRoute,
    goToHashRoute: goToRoute.curry('hash'),
    goToRoute: goToRoute.curry('path'),
    reloadCurrentPage : reloadCurrentPage,
    onParsingStart: onParsingStart,
    enableLogging: enableLogging,
    disableLogging: disableLogging
  };

});

